import '../styles/LoaderComponentStyles.css';
import ClassNames from 'classnames';
import _isArray from 'lodash/isArray';
import React from 'react';
import { Loader as SemanticLoader } from 'semantic-ui-react';
;

const Loader = ({
  text = '',
  isInverted = false,
  isVerticallyCentered = false,
  size = 'large',
  inline = 'centered',
  className = ''
}) => /*#__PURE__*/React.createElement(SemanticLoader, {
  active: true,
  inline: inline,
  size: size,
  className: ClassNames(['loader-component', className, {
    inverted: isInverted,
    'vertically-centered': isVerticallyCentered
  }])
}, !!text && !_isArray(text) && /*#__PURE__*/React.createElement("div", {
  className: "text"
}, text), !!text && _isArray(text) && /*#__PURE__*/React.createElement("div", null, text.map(textLine => /*#__PURE__*/React.createElement("div", {
  key: textLine,
  className: "text"
}, textLine))));

export default Loader;